import React from 'react';
import Spinner from './Spinner';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  title?: string;
  showIcon?: boolean;
}

const spinnerSizes = {
  sm: 'small',
  md: 'medium',
  lg: 'large',
  xl: 'large',
} as const;

export const Loader: React.FC<LoaderProps> = ({
  size = 'md',
  className = '',
  title,
  showIcon = true,
}) => {
  return (
    <div className={`flex flex-col items-center justify-center gap-2 ${className}`}>
      {showIcon && <Spinner size={spinnerSizes[size]} color="var(--color-primary)" />}
      {title && <p className="text-ds-text-secondary">{title}</p>}
    </div>
  );
};
